/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";

type PredefinedSize = "small" | "medium" | "large";
type Size = PredefinedSize | `${number}rem`;

type StatusDotProps = {
  size?: Size;
  color?: string;
};

const sizeMap = {
  small: "0.5rem",
  medium: "0.625rem",
  large: "0.75rem",
};

const getSize = (size: Size = "medium"): string => {
  if (size in sizeMap) {
    return sizeMap[size as PredefinedSize];
  }

  return size;
};

export const StatusDot = styled.div<StatusDotProps>`
  width: ${({ size }) => getSize(size)};
  height: ${({ size }) => getSize(size)};
  background-color: ${({ color = "#4CAF50" }) => color};
  border-radius: 50%;
`;
